import axios from "axios";

const configuredApiUrl = process.env.REACT_APP_API_URL;
const isLocalApiUrl = /^https?:\/\/(?:localhost|127\.0\.0\.1)(?::\d+)?\/?$/i.test(configuredApiUrl || "");

export const API_BASE_URL = process.env.NODE_ENV === "production" && (!configuredApiUrl || isLocalApiUrl)
  ? window.location.origin
  : configuredApiUrl || "http://localhost:5000";

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  withCredentials: true,
});

export function mediaUrl(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;

  // Older records may contain an absolute server filesystem path when
  // UPLOAD_DIR was configured as an absolute path. Keep those files usable.
  const uploadsIndex = url.indexOf("/uploads/");
  const publicPath = uploadsIndex >= 0 ? url.slice(uploadsIndex) : url;
  return `${API_BASE_URL}${publicPath.startsWith("/") ? publicPath : `/${publicPath}`}`;
}

export const contentApi = {
  listContents: (params = {}) => api.get("/contents", { params }).then((res) => res.data),
  getContent: (idOrSlug) => api.get(`/contents/${idOrSlug}`).then((res) => res.data),
  createContent: (formData) =>
    api.post("/contents", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((res) => res.data),
  updateContent: (id, formData) =>
    api.patch(`/contents/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((res) => res.data),
  deleteContent: (id) => api.delete(`/contents/${id}`).then((res) => res.data),
  setForYou: (id, isForYou) => api.patch(`/contents/${id}/for-you`, { isForYou }).then((res) => res.data),
  addMovieVideo: (id, formData, onUploadProgress) =>
    api.post(`/contents/${id}/videos`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress,
    }).then((res) => res.data),
  addSeason: (id, payload) => api.post(`/contents/${id}/seasons`, payload).then((res) => res.data),
  addEpisode: (id, seasonId, payload) =>
    api.post(`/contents/${id}/seasons/${seasonId}/episodes`, payload).then((res) => res.data),
  addEpisodeVideo: (id, seasonId, episodeId, formData, onUploadProgress) =>
    api.post(`/contents/${id}/seasons/${seasonId}/episodes/${episodeId}/videos`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress,
    }).then((res) => res.data),
  listCategories: () => api.get("/categories").then((res) => res.data),
  createCategory: (payload) => api.post("/categories", payload).then((res) => res.data),
  deleteCategory: (id) => api.delete(`/categories/${id}`).then((res) => res.data),
  listGenres: () => api.get("/genres").then((res) => res.data),
  createGenre: (payload) => api.post("/genres", payload).then((res) => res.data),
  deleteGenre: (id) => api.delete(`/genres/${id}`).then((res) => res.data),
};

export const authApi = {
  telegramLogin: (telegramUser, credentials) =>
    api.post("/auth/telegram", { ...telegramUser, ...credentials }).then((res) => res.data),
  startBotAuth: (credentials) => api.post("/auth/telegram/start", credentials).then((res) => res.data),
  botAuthStatus: (token) => api.post("/auth/telegram/status", { token }).then((res) => res.data),
  me: () => api.get("/auth/me").then((res) => res.data),
  logout: () => api.post("/auth/logout").then((res) => res.data),
  watchProgress: () => api.get("/auth/progress").then((res) => res.data),
  contentWatchProgress: (contentId) => api.get(`/auth/progress/${contentId}`).then((res) => res.data),
  saveWatchProgress: (contentId, payload) => api.put(`/auth/progress/${contentId}`, payload).then((res) => res.data),
  logs: (limit = 100) => api.get("/auth/logs", { params: { limit } }).then((res) => res.data),
  users: (limit = 200) => api.get("/auth/users", { params: { limit } }).then((res) => res.data),
  updateSubscription: (userId, payload) => api.patch(`/auth/users/${userId}/subscription`, payload).then((res) => res.data),
};
